export const checkIsLockedAutomation = (period, user) =>
  period?.submit_progress_status === 'Completed' && user?.role !== 'Admin';
